import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { globalStyle, style } from '@vanilla-extract/css';

export const soundButtonContainer = style({
  display: 'flex',
  alignItems: 'center',
});

globalStyle(`${soundButtonContainer} > button:first-child`, {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderRight: `1px solid ${themeVars.container.border.secondary}`,
});

globalStyle(`${soundButtonContainer} > button:last-child`, {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,

  ...responsiveStyle({
    mobile: {
      width: 32,
      height: 32,
    },
    tablet: {
      width: 40,
      height: 40,
    },
  }),
});
